import { Record as record } from 'immutable';

import { construct, fields } from '../../helpers/LinkMapper';

const defaults = {
    id: null,
    amount: null,
    amountRefunded: null,
    originalAmount: null,
    created: null,
    refunded: null,
    pan: null,
    transactionId: null
};

export default class GooglePayPayment extends record(defaults) {

    static fromJSON (json = {}) {
        return construct(GooglePayPayment, json, {
            id: fields.number,
            amount: fields.number,
            amountRefunded: fields.number,
            originalAmount: fields.number,
            created: fields.datetime,
            refunded: fields.bool,
            pan: fields.string,
            transactionId: fields.string
        });
    }

    hasAmount () {
        return this.amount > 0;
    }

    isRefundable () {
        return this.hasAmount();
    }

}
